import { useEffect, useState } from 'react';
import {
    TABLE_BOTTOM_GAP,
    TABLE_HEADER_HEIGHT,
    TABLE_PAGINATION_HEIGHT,
} from './reconPaymentHelpers';

/**
 * Viewport-based DataTable fixedHeaderScrollHeight for reconciliation lists.
 * @param {object} options
 * @param {React.RefObject} options.containerRef
 * @param {number} [options.dataLength]
 * @param {boolean} [options.loading]
 * @param {number} [options.extraBottom] - FAB / page chrome below table
 * @param {number} [options.cardPadding] - vertical padding inside table card
 */
const useReconTableScrollHeight = ({
    containerRef,
    dataLength,
    loading,
    extraBottom = 0,
    cardPadding = 0,
}) => {
    const [tableScrollHeight, setTableScrollHeight] = useState('600px');

    useEffect(() => {
        const updateTableHeight = () => {
            const containerTop =
                containerRef.current?.getBoundingClientRect().top ?? 220;
            const maxBodyHeight =
                window.innerHeight -
                containerTop -
                TABLE_HEADER_HEIGHT -
                TABLE_PAGINATION_HEIGHT -
                TABLE_BOTTOM_GAP -
                Number(extraBottom || 0) -
                Number(cardPadding || 0);
            setTableScrollHeight(`${Math.max(maxBodyHeight, 320)}px`);
        };

        const raf = window.requestAnimationFrame(updateTableHeight);
        window.addEventListener('resize', updateTableHeight);

        let observer;
        if (typeof ResizeObserver !== 'undefined' && containerRef.current) {
            observer = new ResizeObserver(updateTableHeight);
            observer.observe(containerRef.current);
            if (containerRef.current.parentElement) {
                observer.observe(containerRef.current.parentElement);
            }
        }

        return () => {
            window.cancelAnimationFrame(raf);
            window.removeEventListener('resize', updateTableHeight);
            observer?.disconnect();
        };
    }, [containerRef, dataLength, loading, extraBottom, cardPadding]);

    return tableScrollHeight;
};

export default useReconTableScrollHeight;
